import { render } from "./WorkspaceNetworkError.vue?vue&type=template&id=10c437d7&ts=true"
import script from "./WorkspaceNetworkError.vue?vue&type=script&lang=ts"
export * from "./WorkspaceNetworkError.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__